export enum Day {
    Maandag = 1,
    Dinsdag = 2,
    Woensdag = 3,
    Donderdag = 4,
    Vrijdag = 5,
    Zaterdag = 6,
    Zondag = 7,
}